import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { IIban } from '../../../core/interfaces/iban.interface';
import { NgClass, NgIf } from '@angular/common';
import { IbanService } from 'src/app/core/services/iban.service';

@Component({
  selector: 'aig-iban-field',
  imports: [ReactiveFormsModule, NgIf, NgClass],
  templateUrl: './iban-field.component.html',
  styleUrl: './iban-field.component.scss',
  standalone: true,
})
export class IbanFieldComponent {
  @Input() parentForm: FormGroup = new FormGroup({});
  @Input() mandatory!: boolean;
  @Output() ibanChange = new EventEmitter<string>();

  private ibanCountry: string = 'ES';
  private ibanIntroducido: string = '';

  public invalidIban: boolean = false;

  constructor(private ibanService: IbanService) {}

  checkIban(field: string) {
    const ibanCountry = 'ES';
    this.ibanIntroducido =
      ibanCountry +
      this.parentForm.get('iban1')?.value +
      this.parentForm.get('iban2')?.value +
      this.parentForm.get('iban3')?.value +
      this.parentForm.get('iban4')?.value +
      this.parentForm.get('iban5')?.value;

    this.ibanChange.emit(this.ibanIntroducido); // Emitir IBAN completo

    let val = this.parentForm.get(field)?.value;
    let maxLength = 10;

    switch (field) {
      case 'iban1':
        maxLength = 2;
        if (val.length >= maxLength) {
          var el = document.getElementById('iban2');
          el?.focus();
        }
        break;
      case 'iban2':
        if (val.length >= 4) {
          var el = document.getElementById('iban3');
          el?.focus();
        }
        break;
      case 'iban3':
        if (val.length >= 4) {
          var el = document.getElementById('iban4');
          el?.focus();
        }
        break;
      case 'iban4':
        if (val.length >= 2) {
          var el = document.getElementById('iban5');
          el?.focus();
        }
        break;
    }
    if (this.ibanIntroducido.length === 24) {
      let iban: IIban = {
        iban: this.ibanIntroducido,
      };

      this.ibanService.checkIBAN(iban).subscribe({
        next: (res) => {
          if (res && res.isValid !== undefined) {
            this.invalidIban = !res.isValid;
          } else {
            this.invalidIban = true; // Handle unexpected response structure
          }
        },
        error: (err) => {
          this.invalidIban = true;
        },
      });
    } else {
      this.invalidIban = true;
    }
  }
}
